import IntegrationsProvider from 'views/Integrations';
import {
  AuthenticateView,
  CallbackView,
  FourZeroFourView,
  LoadingView,
  BasicAuthView,
} from 'views/Interstitial';
import ResourceMapperProvider from 'views/ResourceMapper';
import { RoutePaths } from './history';
import { FieldMatchingView } from 'views/FieldMatching/field-matching.view';

export const IntegrationsObject = {
  path: RoutePaths.Integrations(),
  Component: IntegrationsProvider,
  name: 'Integrations',
  manual_subheader: true,
};

export const AuthenticateObject = {
  path: RoutePaths.AuthenticateView(),
  Component: AuthenticateView,
};

export const FourZeroFourViewObject = {
  path: RoutePaths.FourZeroFourView(),
  Component: FourZeroFourView,
};

export const CallbackViewObject = {
  path: RoutePaths.CallbackView(),
  Component: CallbackView,
};

export const BasicAuthViewObject = {
  path: RoutePaths.BasicAuthView(),
  Component: BasicAuthView,
};

export const IntegrationConfigurationObject = {
  path: RoutePaths.ConfigureIntegrationWizardView(),
  Component: IntegrationsProvider,
  name: 'Configure Integration',
  manual_subheader: true,
};

export const successRoutes: any[] = [
  CallbackViewObject,
  {
    path: RoutePaths.ResourceMapperView(),
    Component: ResourceMapperProvider,
    name: 'Resource Mapper',
    manual_subheader: true,
  },
  {
    path: RoutePaths.FieldMatchingView(),
    Component: FieldMatchingView,
    name: 'Field Matching',
    manual_subheader: true,
  },
  IntegrationsObject,
  AuthenticateObject,
  FourZeroFourViewObject,
  BasicAuthViewObject,
  IntegrationConfigurationObject,
];

export const loadingRoutes: any[] = [
  CallbackViewObject,
  AuthenticateObject,
  FourZeroFourViewObject,
  {
    path: '/',
    Component: LoadingView,
  },
];

export const failRoutes: any[] = [
  {
    path: '/',
    Component: FourZeroFourView,
  },
];
